module.exports = __webpack_public_path__ + "media/images/unpin-99a74701bd3c832f03d4d61b60d3fa71.svg";